module.exports = __webpack_public_path__ + "static/media/pastafarianism.7f7e2d8b.svg";